import React, {useRef, useState} from 'react';
import Popup from "reactjs-popup";

import useScroll from "ubs-framework/v2/hooks/useScroll";
import * as Icon from "ubs-icons";
import {COLOR} from "ubs-framework/v2/common/constant";
import UInput from "ubs-framework/v2/UInput";

const InputFilter = React.memo((props) => {
    const popupRef = useRef(null)
    const [name, setName] = useState('')
    const handle = {
        blur: e => {
            if (name) props?.onChange(name)
        },
        change: e => {
            let value = e?.target?.value
            if(e?.target?.name === 'contactNo'){
                if(value.length < 12) {
                    value = value.replace(/[^0-9.  +]/g, '').replace(/(\..*)\./g, '$1')
                } else {
                  return false
                }
            }
            setName(value)
        },
        clearData: e => {
            e.stopPropagation()
            props?.onChange('')
            if (popupRef?.current) popupRef?.current?.open()
        },
        enter: e => {
            if (e.key === 'Enter') {
                if (name) props?.onChange(name)
                if (popupRef?.current) popupRef?.current?.close()
            }
        }
    }

    useScroll(document.getElementsByClassName('u_import-scroll')[0], (e) => {
        if (popupRef.current) popupRef.current.close()
    });

    // useEffect(() => {
    //     setName(props?.errorTitle)
    // }, [props?.errorTitle])

    return (
        <React.Fragment>
            <Popup
                ref={popupRef}
                trigger={open => (
                    <div className="u_import-data-input">
                        <p className="u_small-font u_cp  u_flex u_align-center" onClick={(e) => handle.clearData(e)}>
                            <span className="u_mr-5 u_flex-1">{props?.errorTitle || props?.placeholder}</span>
                            <Icon.Edit fill={COLOR.u_title} size={14}/>
                        </p>
                    </div>
                )}
                position="bottom center"
                closeOnDocumentClick
                closeOnEscape
                className="u_popover-container"
                arrow={false}
                contentStyle={{zIndex: 10001}}
                onClose={handle.blur}
            >
                <UInput label={props?.placeholder} hasError={false} isFocused={true}>
                    <input placeholder=" " autoComplete='off' value={name} name={props?.name || ''}
                           onKeyDown={(e) => handle.enter(e)}
                           onChange={(e) => handle.change(e)}/>
                </UInput>
            </Popup>
        </React.Fragment>
    );
});

export default InputFilter;
